import React, { useState, useEffect } from "react";
import { Table, Modal } from "react-bootstrap"; // Import Modal here
import ExportApi from "../api/ExportApi";
import { toast } from "react-toastify";

function ShippingDescriptions() {
  const [showModal, setShowModal] = useState(false);
  const [shippingData, setShippingData] = useState([]);
  const [singleData, setSingleData] = useState({});
  const [description, setDescription] = useState("");

  useEffect(() => {
    ExportApi.getStatusList()
      .then((resp) => {
        setShippingData(resp?.data?.detail);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error fetching shipping data");
      });
  }, []);

  const handleSingleData = (id) => {
    setShowModal(true);

    ExportApi.getStatusList()
      .then((resp) => {
        if (resp.status === 200 && resp.data.status === "1") {
          const selectedData = resp.data.detail.find((item) => item?._id === id);

          if (selectedData) {
            setSingleData(selectedData);
            setDescription(selectedData?.description);
          } else {
            toast.error("Selected status not found");
          }
        } else {
          toast.error("Failed to fetch status list");
        }
      })
      .catch((error) => {
        console.error("Error fetching status list:", error);
        toast.error("Error fetching status list");
      });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShippingEdit = (e, id, description) => {
    e.preventDefault();

    // Send the updated description to the server
    ExportApi.getupdateStatusList(id, description)
      .then((resp) => {
        if (
          resp.status === 200 &&
          resp.data.status === "1" &&
          resp.data.detail.modifiedCount > 0
        ) {
          toast.success("Details Edited Successfully");

          // Update the state with the new description
          setShippingData((prevData) =>
            prevData.map((item) =>
              item._id === id ? { ...item, description: description } : item
            )
          );
          setShowModal(false);
        } else {
          toast.error("Error updating details: No changes made");
          setShowModal(false);
        }
      })
      .catch((error) => {
        toast.error("Error updating details");
        setShowModal(false);
      });
  };

  return (
    <div className="shipping mt-5">
      <h2>Shipping Details</h2>
      <Table striped className="align-middle mt-4">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {shippingData?.length > 0 ? (
            shippingData.map((data, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{data.name}</td>
                <td>{data.description}</td>
                <td>
                  <button
                    className="btn d-flex align-items-center"
                    onClick={() => handleSingleData(data?._id)}
                  >
                    Edit
                    <span>
                      <svg
                        fill="#000000"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 494.936 494.936"
                      >
                        <g>
                          <path d="M389.844,182.85c-6.743,0-12.21,5.467-12.21,12.21v222.968c0,23.562-19.174,42.735-42.736,42.735H67.157 c-23.562,0-42.736-19.174-42.736-42.735V150.285c0-23.562,19.174-42.735,42.736-42.735h267.741c6.743,0,12.21-5.467,12.21-12.21 s-5.467-12.21-12.21-12.21H67.157C30.126,83.13,0,113.255,0,150.285v267.743c0,37.029,30.126,67.155,67.157,67.155h267.741 c37.03,0,67.156-30.126,67.156-67.155V195.061C402.054,188.318,396.587,182.85,389.844,182.85z"></path>
                        </g>
                      </svg>
                    </span>
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <h5 className="text-center">No Data Found</h5>
          )}
        </tbody>
      </Table>

      {/* Modal for editing */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <form onSubmit={(e) => handleShippingEdit(e, singleData._id, description)}>
            <div className="input-container my-4">
              <label>Description</label>
              <input
                type="text"
                className="form-control"
                //placeholder={singleData?.description}
                value={description}
                onChange={(e) => setDescription(e.target.value)} // Update description state on input change
              />
            </div>
            <div className="buttons d-flex justify-content-center mt-4">
              <button type="submit" className="btn btn-primary me-4">
                Edit
              </button>
              <button type="button" className="btn btn-danger" onClick={handleCloseModal}>
                Cancel
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ShippingDescriptions;
